import { render, staticRenderFns } from "./drillDetail.vue?vue&type=template&id=98b68306&scoped=true&"
import script from "./drillDetail.vue?vue&type=script&lang=js&"
export * from "./drillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b68306",
  null
  
)

export default component.exports